<template>
  <ul class="tab-filter">
    <li
      class="tab-filter__item"
      :class="{'tab-filter__item--active': activeItem === item}"
      v-for="item in items"
      :key="item.value"
      @click="onChange(item)"
    >
      {{ item.text }}
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    items: Array,
    activeItem: null,
    onChange: Function,
  }
}
</script>